import { ErrorInfo, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { DefaultErrorBoundaryFallback } from 'shared/components/error-handling/DefaultErrorBoundaryFallback';

type Props = {
    children: ReactNode;
    reactPlugin: ReactPlugin;
};

export const DefaultErrorBoundary = ({ children, reactPlugin }: Props) => {
    const location = useLocation();

    const handleError = (error: Error, errorInfo: ErrorInfo) => {
        reactPlugin &&
            reactPlugin?.trackException({
                error,
                exception: error,
                severityLevel: SeverityLevel.Error,
                properties: errorInfo
            });
    };

    return (
        <ErrorBoundary key={location.pathname} FallbackComponent={DefaultErrorBoundaryFallback} onError={handleError}>
            {children}
        </ErrorBoundary>
    );
};
